import { render } from "./BaseHeader.vue?vue&type=template&id=79a6f626"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kutchinaasp-uat.kutchina.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__